import { useState } from "react";
import styled from "styled-components/macro";
import Help from "@mui/icons-material/Help";
import { IconButton } from "@mui/material";
import { LotInfoBarGuidedTour } from "components/SimpleComponents/GuidedTour/GuidedTours";

export function HelpButton() {
  const [isTourEnabled, setIsTourEnabled] = useState(false);

  return (
    <>
      {isTourEnabled && (
        <LotInfoBarGuidedTour setIsTourEnabled={setIsTourEnabled} />
      )}
      <HelpButtonStyles>
        <IconButton
          size="small"
          onClick={() => {
            setIsTourEnabled(true);
          }}
        >
          <Help />
        </IconButton>
      </HelpButtonStyles>
    </>
  );
}
const HelpButtonStyles = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: scale(0.8);
  transform-origin: top right;
  opacity: 0.3;
`;
